var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("Content", { staticClass: "app-container home" }, [
    _c(
      "div",
      { staticClass: "station-top" },
      [
        _c(
          "el-row",
          { staticClass: "mt5", attrs: { gutter: 12 } },
          [
            _c("el-col", { attrs: { span: 6 } }, [
              _c(
                "div",
                {
                  staticClass: "top-item-box item-box-one",
                  staticStyle: { display: "flex" },
                },
                [
                  _c("div", { staticStyle: { flex: "2", height: "100%" } }, [
                    _c("div", [_vm._v("今年总数据")]),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "text-align": "center",
                          "margin-top": "30px",
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "font-size": "26px",
                              "font-weight": "bold",
                            },
                          },
                          [_vm._v(_vm._s(_vm.formData.total))]
                        ),
                      ]
                    ),
                  ]),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        flex: "3",
                        display: "flex",
                        "flex-direction": "column",
                        "justify-content": "space-evenly",
                      },
                    },
                    [
                      _c("div", [
                        _vm._v(
                          "当月总数据：" + _vm._s(_vm.formData.monthTotal)
                        ),
                      ]),
                      _c("div", [
                        _vm._v("今日新增：" + _vm._s(_vm.formData.todayTotal)),
                      ]),
                      _c("div", [
                        _vm._v("今日正常：" + _vm._s(_vm.formData.todayNormal)),
                      ]),
                      _c("div", [
                        _vm._v(
                          "今日异常：" + _vm._s(_vm.formData.todayAnomaly)
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
            ]),
            _c("el-col", { attrs: { span: 6 } }, [
              _c(
                "div",
                {
                  staticClass: "top-item-box item-box-two",
                  staticStyle: { display: "flex" },
                },
                [
                  _c("div", { staticStyle: { flex: "2", height: "100%" } }, [
                    _c("div", [_vm._v("ABC表")]),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "text-align": "center",
                          "margin-top": "30px",
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "font-size": "26px",
                              "font-weight": "bold",
                            },
                          },
                          [_vm._v(_vm._s(_vm.formData.abcYearTotal))]
                        ),
                      ]
                    ),
                  ]),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        flex: "3",
                        display: "flex",
                        "flex-direction": "column",
                        "justify-content": "space-evenly",
                      },
                    },
                    [
                      _c("div", [
                        _vm._v(
                          "当月总数据：" + _vm._s(_vm.formData.abcMonthTotal)
                        ),
                      ]),
                      _c("div", [
                        _vm._v(
                          "今日新增：" + _vm._s(_vm.formData.abcTodayTotal)
                        ),
                      ]),
                      _c("div", [
                        _vm._v(
                          "今日正常：" + _vm._s(_vm.formData.abcTodayNormal)
                        ),
                      ]),
                      _c("div", [
                        _vm._v(
                          "今日异常：" + _vm._s(_vm.formData.abcTodayAnomaly)
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
            ]),
            _c("el-col", { attrs: { span: 6 } }, [
              _c(
                "div",
                {
                  staticClass: "top-item-box item-box-three",
                  staticStyle: { display: "flex" },
                },
                [
                  _c("div", { staticStyle: { flex: "2", height: "100%" } }, [
                    _c("div", [_vm._v("多动症量表")]),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "text-align": "center",
                          "margin-top": "30px",
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "font-size": "26px",
                              "font-weight": "bold",
                            },
                          },
                          [_vm._v(_vm._s(_vm.formData.connerYearTotal))]
                        ),
                      ]
                    ),
                  ]),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        flex: "3",
                        display: "flex",
                        "flex-direction": "column",
                        "justify-content": "space-evenly",
                      },
                    },
                    [
                      _c("div", [
                        _vm._v(
                          "当月总数据：" + _vm._s(_vm.formData.connerMonthTotal)
                        ),
                      ]),
                      _c("div", [
                        _vm._v(
                          "今日新增：" + _vm._s(_vm.formData.connerTodayTotal)
                        ),
                      ]),
                      _c("div", [
                        _vm._v(
                          "今日正常：" + _vm._s(_vm.formData.connerTodayNormal)
                        ),
                      ]),
                      _c("div", [
                        _vm._v(
                          "今日异常：" + _vm._s(_vm.formData.connerTodayAnomaly)
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
            ]),
            _c("el-col", { attrs: { span: 6 } }, [
              _c(
                "div",
                {
                  staticClass: "top-item-box item-box-four",
                  staticStyle: { display: "flex" },
                },
                [
                  _c("div", { staticStyle: { flex: "2", height: "100%" } }, [
                    _c("div", [_vm._v("M-CHAT表")]),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "text-align": "center",
                          "margin-top": "30px",
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "font-size": "26px",
                              "font-weight": "bold",
                            },
                          },
                          [_vm._v(_vm._s(_vm.formData.mchatYearTotal))]
                        ),
                      ]
                    ),
                  ]),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        flex: "3",
                        display: "flex",
                        "flex-direction": "column",
                        "justify-content": "space-evenly",
                      },
                    },
                    [
                      _c("div", [
                        _vm._v(
                          "当月总数据：" + _vm._s(_vm.formData.mchatMonthTotal)
                        ),
                      ]),
                      _c("div", [
                        _vm._v(
                          "今日新增：" + _vm._s(_vm.formData.mchatTodayTotal)
                        ),
                      ]),
                      _c("div", [
                        _vm._v(
                          "今日正常：" + _vm._s(_vm.formData.mchatTodayNormal)
                        ),
                      ]),
                      _c("div", [
                        _vm._v(
                          "今日异常：" + _vm._s(_vm.formData.mchatTodayAnomaly)
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
            ]),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }